import React from 'react';
import { useNotification } from '../NotificationContext';
import NotificationToast from './NotificationToast';

const GlobalNotification = () => {
  const { notification, hideNotification } = useNotification();

  if (!notification) {
    return null;
  }

  return (
    <NotificationToast
      key={notification.id}
      show
      type={notification.type}
      message={notification.message}
      onClose={hideNotification}
    />
  );
};

export default GlobalNotification;
